import React, { Component } from "react";
import {Helmet} from 'react-helmet'

class PageHelmet extends Component{
    render(){
        return(
            <React.Fragment>
                <Helmet>
                    <title>|| eriksresume.com</title>
                    <meta name="description" content="eriksresume.com - " />
                </Helmet>
            </React.Fragment>
        )
    }
}


export default PageHelmet;
